import { AddToCartType } from './interface.es.js';
import { trackCustomEvent } from './helper.es.js';

const trackAddToCart = (trackAddToCartParams) => {
  var _a;
  const {
    product,
    selectedPromotionId,
    status,
    cartId,
    type = AddToCartType.ADDTOCART
  } = trackAddToCartParams;
  const { defaultPromotions = [] } = product;
  const trackingData = {
    cartId,
    skuId: product.productInfo.sku,
    skuName: product.productInfo.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: parseInt(product.prices[0].supplierRetailPrice),
    promotionPrice: product.addToCartPrice
  };
  if (type === AddToCartType.ADDTOCART) {
    window.track(AddToCartType.ADDTOCART, trackingData);
  } else {
    trackCustomEvent(AddToCartType.BUYNOW, {
      action: "click",
      category: "cart",
      label: JSON.stringify(trackingData),
      property: "product"
    });
  }
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: type,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.productInfo.name,
            id: product.productInfo.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: ""
          }
        ]
      }
    }
  });
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: AddToCartType.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a;
  window.track("removeFromCart", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};

export { trackAddToCart, trackAddToCartManually, trackChangeQuantityProduct, trackDecreaseQuantityProduct, trackIncreaseQuantityProduct, trackManually, trackRemoveFromCart, trackSelectProduct };
